// extracted by mini-css-extract-plugin
export default {"image":"t1-z","loaded":"u1-z"};